import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { hideMessage } from '../../actions/hide-message';
import Message from '../../components/message';
import ScrollListener from '../../components/scroll-listener';
import withDeviceType from '../../hoc/with-device-type';

const CLOSE_TIMEOUT = 3000;
const ANIMATION_TIMEOUT = 400;

export class MessageRoot extends Component {
  state = {};

  componentWillReceiveProps(nextProps) {
    const { type } = this.props;
    // TODO: implement this using middleware or something
    if (type !== nextProps.type) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.hideMessage, CLOSE_TIMEOUT);
    }
  }

  hideMessage = () => {
    this.props.hideMessage();
    this.timeout = undefined;
  };

  handleScroll = scroll => {
    const { scroll: { scrollTop, height } = {} } = this.state;
    const { isDesktop } = this.props;
    if (isDesktop && this.timeout && scrollTop !== scroll.scrollTop && height === scroll.height) {
      clearTimeout(this.timeout);
      this.hideMessage();
    }
    this.setState({ scroll });
  };

  render() {
    const { scroll: { scrollTop, y } = {} } = this.state;
    const { type, content, hideMessage, isDesktop } = this.props;
    const top = isDesktop ? Math.max(0, scrollTop - y) : 0;
    return (
      <CSSTransitionGroup
        component="div"
        transitionName="message"
        transitionEnterTimeout={ANIMATION_TIMEOUT}
        transitionLeaveTimeout={ANIMATION_TIMEOUT}
      >
        {content ? <Message type={type} content={content} onClose={hideMessage} top={top}/> : null}
        <ScrollListener onScroll={this.handleScroll}/>
      </CSSTransitionGroup>
    );
  }
}

MessageRoot.propTypes = {
  hideMessage: PropTypes.func.isRequired,
  type: PropTypes.string,
  content: PropTypes.any,
  isDesktop: PropTypes.bool,
  scroll: PropTypes.object,
};

const mapStateToProps = state => ({
  type: state.message.type,
  content: state.message.content,
});

const mapDispatchToProps = {
  hideMessage,
};

export default _.flowRight(connect(mapStateToProps, mapDispatchToProps), withDeviceType)(MessageRoot);



// WEBPACK FOOTER //
// ./app/containers/message-root/message-root.js